import React from 'react';
import clsx from 'clsx';
import { MMediaSelector } from '../../molecules/MMediaSelector';
import { ABody, ABodySize, ABodyColor } from '../../atoms/ABody';
import * as Styled from './OMediaCaption.styles';
import type { OMediaCaptionProps } from './OMediaCaption.types';

const COMPONENT_NAME = 'o-web-ui-kit-OMediaCaption';
const TEST_ID = 'web-ui-kit-OMediaCaption';

export const OMediaCaption: React.FC<OMediaCaptionProps> = ({ mMediaSelector, aBody, className }) => {
  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} className={clsx(className)}>
      <Styled.MediaWrapper>{mMediaSelector && <MMediaSelector {...mMediaSelector} />}</Styled.MediaWrapper>
      <Styled.CaptionWrapper>
        <ABody
          bodyText={aBody?.bodyText}
          size={aBody?.size ?? ABodySize.S}
          color={aBody?.color ?? ABodyColor.Alternate}
        />
      </Styled.CaptionWrapper>
    </Styled.Wrapper>
  );
};
